import { creditConstants } from '../constants';
import { creditRequests } from '../../services';
import { handleErrorMessage } from '../../utils';

export const creditActions = {}

creditActions.GetNewCreditOption = (data) => {
  return dispatch => {
    dispatch(request())
    creditRequests.GetNewCreditOption(data)
      .then(
        creditData => dispatch(success(creditData)),
        error => dispatch(failure(handleErrorMessage(error)))
      )
  }

  function request() {
    return { type: creditConstants.CREDITOPTION_REQUEST }
  }

  function success(creditData) {
    return { type: creditConstants.CREDITOPTION_SUCCESS, creditData }
  }

  function failure(error) {
    return { type: creditConstants.CREDITOPTION_FAILURE, error }
  }
}

creditActions.AsignateNewCreditOption = (data) => {
  return dispatch => {
    dispatch(request())
    creditRequests.AsignateNewCreditOption(data)
      .then(
        asignatedCreditData => dispatch(success(asignatedCreditData)),
        error => dispatch(failure(handleErrorMessage(error.message)))
      )
  }

  function request() {
    return { type: creditConstants.ASIGNATE_CREDITOPTION_REQUEST }
  }

  function success(asignatedCreditData) {
    return { type: creditConstants.ASIGNATE_CREDITOPTION_SUCCESS, asignatedCreditData }
  }

  function failure(error) {
    return { type: creditConstants.ASIGNATE_CREDITOPTION_FAILURE, error }
  }
}

creditActions.GetCobranzaPagos = (data) => {
  return dispatch => {
    dispatch(request())
    creditRequests.GetCobranzaPagos(data)
      .then(
        cobranzaCredData => dispatch(success(cobranzaCredData)),
        error => dispatch(failure(handleErrorMessage(error)))
      )
  }

  function request() {
    return { type: creditConstants.COBRANZA_PAGOS_REQUEST }
  }

  function success(cobranzaCredData) {
    return { type: creditConstants.COBRANZA_PAGOS_SUCCESS, cobranzaCredData }
  }

  function failure(error) {
    return { type: creditConstants.COBRANZA_PAGOS_FAILURE, error }
  }
}

creditActions.GenerarDatosCobranzaUnico = (data) => {
  return dispatch => {
    dispatch(request())
    creditRequests.GenerarDatosCobranzaUnico(data)
      .then(
        generaCzaCredData => dispatch(success(generaCzaCredData)),
        error => dispatch(failure(handleErrorMessage(error)))
      )
  }

  function request() {
    return { type: creditConstants.GENERAR_DATOS_COBRNZA_UNICO_REQUEST }
  }

  function success(generaCzaCredData) {
    return { type: creditConstants.GENERAR_DATOS_COBRNZA_UNICO_SUCCESS, generaCzaCredData }
  }

  function failure(error) {
    return { type: creditConstants.GENERAR_DATOS_COBRNZA_UNICO_FAILURE, error }
  }
}

creditActions.GetCobranzaCobro = (data) => {
  return dispatch => {
    dispatch(request())
    creditRequests.GetCobranzaCobro(data)
      .then(
        cobranzaCobro => dispatch(success(cobranzaCobro)),
        error => dispatch(failure(handleErrorMessage(error)))
      )
  }

  function request() {
    return { type: creditConstants.COBRANZA_COBRO_REQUEST }
  }

  function success(cobranzaCobro) {
    return { type: creditConstants.COBRANZA_COBRO_SUCCESS, cobranzaCobro }
  }

  function failure(error) {
    return { type: creditConstants.COBRANZA_COBRO_FAILURE, error }
  }
}

creditActions.GetUserGoal = (data) => {
  return dispatch => {
    dispatch(request())
    creditRequests.GetUserGoal(data)
      .then(
        userData => dispatch(success(userData)),
        error => dispatch(failure(handleErrorMessage(error)))
      )
  }

  function request() {
    return { type: creditConstants.GETUSERS_GOAL_REQUEST }
  }

  function success(userData) {
    return { type: creditConstants.GETUSERS_GOAL_SUCCESS, userData }
  }

  function failure(error) {
    return { type: creditConstants.GETUSERS_GOAL_FAILURE, error }
  }
}

creditActions.RegisterUserGoal = (data) => {
  return dispatch => {
    dispatch(request())
    creditRequests.RegisterUserGoal(data)
      .then(
        regUserData => dispatch(success(regUserData)),
        error => dispatch(failure(handleErrorMessage(error)))
      )
  }

  function request() {
    return { type: creditConstants.REGISTER_USER_GOAL_REQUEST }
  }

  function success(regUserData) {
    return { type: creditConstants.REGISTER_USER_GOAL_SUCCESS, regUserData }
  }

  function failure(error) {
    return { type: creditConstants.REGISTER_USER_GOAL_FAILURE, error }
  }
}

creditActions.GetDependencies = (data) => {
  return dispatch => {
    dispatch(request())
    creditRequests.GetDependencies(data)
      .then(
        dependData => dispatch(success(dependData)),
        error => dispatch(failure(handleErrorMessage(error)))
      )
  }

  function request() {
    return { type: creditConstants.GETDEPENDENCIES_REQUEST }
  }

  function success(dependData) {
    return { type: creditConstants.GETDEPENDENCIES_SUCCESS, dependData }
  }

  function failure(error) {
    return { type: creditConstants.GETDEPENDENCIES_FAILURE, error }
  }
}

creditActions.GetCalculateDataFile = (data) => {
  return dispatch => {
    dispatch(request())
    creditRequests.GetCalculateDataFile(data)
      .then(
        calculaData => dispatch(success(calculaData)),
        error => dispatch(failure(handleErrorMessage(error)))
      )
  }

  function request() {
    return { type: creditConstants.GETCALCULATE_DATAFILE_REQUEST }
  }

  function success(calculaData) {
    return { type: creditConstants.GETCALCULATE_DATAFILE_SUCCESS, calculaData }
  }

  function failure(error) {
    return { type: creditConstants.GETCALCULATE_DATAFILE_FAILURE, error }
  }
}